<!-- <script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import { onMount } from 'svelte';
    import { _completeExamData, _userObj } from "./store.js";
    let userObj = {
        name: "",
        mobileNo: ""
    };

    let loaded = false;

    let completeExamData = {};
    export let token;

    async function api_getInfo() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            token: token,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('https://test.testsdlc.in/testAPI/getInfo', requestOptions);
            // var resObj = await fetch('http://test.localhost:8080/testAPI/getInfo', requestOptions);
             
            var response = await resObj.json();
            return response;
        } catch (error) {   
            console.error("error", error);
            return { error: error };
        }
    }

    async function api_getMyTests(testObj) {
        var requestOptions = {
            method: "GET",
        };
        try {
            var resObj = await fetch(  "/testAPI/testData/" + testObj.orgId + "/" + testObj.testId + ".json", requestOptions);
            console.log("resObj : ", resObj)
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }


    _userObj.subscribe(value => { userObj = value });
    _completeExamData.subscribe(value => { completeExamData = value });


    onMount(async () => {
        if (!userObj.name) {
            let tokenRes = await api_getInfo();
            userObj = tokenRes.userObj;
            _userObj.set(userObj);

            if (tokenRes.doneTest) {
                alert("Test already submitted")
                navigate("/result/" + tokenRes.doneTest._id, { replace: true })
            }

            // let response = await api_getMyTests({
            //     orgId: userObj.orgId,
            //     testId: tokenRes.testId
            // });
            // _completeExamData.set(response);

            
            // console.log("response : ", response)
            _completeExamData.set(JSON.parse(tokenRes.completeTestData.testData));

            if(tokenRes.onGoingTest){
                navigate("/questions/" + token + "/"+ tokenRes.onGoingTest.currentQuestionNo+"/"+ tokenRes.onGoingTest.currentSectionNo)
            }
        }else{
            console.log("Loaded")
        }
        loaded = true;
    });
</script> -->

<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { _completeExamData, _userObj } from "./store.js";

  let userObj = {
    name: "",
    mobileNo: "",
  };

  let loaded = false;
  let completeExamData = {};
  export let token;

  async function api_getInfo() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var payload = JSON.stringify({ token: token });
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: payload,
    };
    try {
      // DYNAMIC URL: Works locally and in production automatically!
      const baseUrl = window.location.origin;
      var resObj = await fetch(baseUrl + "/testAPI/getInfo", requestOptions);

      const contentType = resObj.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        var response = await resObj.json();
https://ims.testsdlc.in/dashboard
        console.log("===========");
        console.log("✅ API RESPONSE: ", response);
        console.log("===========");
        

        return response;
      } else {
        console.error("❌ THE SERVER RETURNED HTML INSTEAD OF JSON!");
        return {
          error: "HTML returned instead of JSON. Server might be down.",
        };
      }
    } catch (error) {
      console.error("❌ NETWORK ERROR: ", error);
      return { error: error };
    }
  }

  _userObj.subscribe((value) => {
    userObj = value;
  });
  _completeExamData.subscribe((value) => {
    completeExamData = value;
  });

  onMount(async () => {
    if (!userObj.name) {
      let tokenRes = await api_getInfo();

      // 4. PREVENT THE CRASH ON LINE 77
      if (tokenRes.error || !tokenRes.userObj) {
        console.error("FATAL: API failed to return valid user data.", tokenRes);
        alert(
          "Server routing error: Failed to load test data. Check the console.",
        );
        return; // STOP execution here so the app doesn't crash!
      }

      userObj = tokenRes.userObj;
      _userObj.set(userObj);

      if (tokenRes.doneTest) {
        alert("Test already submitted");
        navigate("/result/" + tokenRes.doneTest._id, { replace: true });
        return;
      }

      // SAFE CHECK BEFORE PARSING TEST DATA
      if (tokenRes.completeTestData && tokenRes.completeTestData.testData) {
        _completeExamData.set(JSON.parse(tokenRes.completeTestData.testData));
      } else {
        console.error(
          "FATAL: completeTestData is missing from the API response!",
        );
        return;
      }

      if (tokenRes.onGoingTest) {
        navigate(
          "/questions/" +
            token +
            "/" +
            tokenRes.onGoingTest.currentQuestionNo +
            "/" +
            tokenRes.onGoingTest.currentSectionNo,
        );
      }
    } else {
      console.log("Loaded from store");
    }

    loaded = true;
  });
</script>

{#if loaded}
  <div class="inst-container">
    <div class="inst-header">
      {completeExamData.name ? completeExamData.name : ""}
    </div>
    <div class="inst-general-inst">
      <div class="inst-body">
        <h4>General Instructions:</h4>
        <ol start="1">
          <li>
            <p>
              The clock will be set at the server. The countdown timer at the
              top right corner of screen will display the remaining time
              available for you to complete the examination. When the timer
              reaches zero, the examination will end by itself. You need not
              terminate the examination or submit your paper.
            </p>
          </li>
          <li>
            <p>
              The Question Palette displayed on the right side of screen will
              show the status of each question using one of the following
              symbols:
            </p>
            <ul class="que-ans-states">
              <li>
                <span class="label"></span> You have not visited the question yet.
              </li>
              <li>
                <span class="label skipped"></span> You have not answered the question.
              </li>
              <li>
                <span class="label attempted"></span> You have answered the question.
              </li>
              <li>
                <span class="label bookmarked"></span> You have NOT answered the
                question, but have marked the question for review.
              </li>
              <li>
                <span class="label attempted bookmarked"></span> You have answered
                the question, but marked it for review.
              </li>
            </ul>
          </li>
        </ol>
        <p>
          The <b>Mark For Review </b> status for a question simply indicates that
          you would like to look at that question again. If a question is answered,
          but marked for review, then the answer will be considered for evaluation
          unless the status is modified by the candidate.
        </p>
        <b> Navigating to a Question : </b>
        <ol start="3">
          <li>
            <p>To answer a question, do the following:</p>
            <ol>
              <li>
                Click on the question number in the Question Palette at the
                right of your screen to go to that numbered question directly.
                Note that using this option does NOT save your answer to the
                current question.
              </li>
              <li>
                Click on <b> Save &amp; Next </b> to save your answer for the current
                question and then go to the next question.
              </li>
              <li>Click on <b> Mark for Review </b> to mark it for review.</li>
            </ol>
          </li>
        </ol>
        <p>
          Note that your answer for the current question will not be saved, if
          you navigate to another question directly by clicking on a question
          number <span> without saving </span> the answer to the previous question.
        </p>
        <p>
          You can view all the questions by clicking on the <b>
            Question Paper
          </b>
          button. <br /><span style="color:#ff0000"
            >This feature is provided, so that if you want you can just see the
            entire question paper at a glance.
          </span>
        </p>
        <h4>Answering a Question :</h4>
        <ol start="4">
          <li>
            <p>
              Procedure for answering a multiple choice (MCQ) type question:
            </p>
            <ol>
              <li>
                Choose one answer from the 4 options (A,B,C,D) given below the
                question, click on the bubble placed before the chosen option.
              </li>
              <li>
                To deselect your chosen answer, click on the bubble of the
                chosen option again or click on the <b> Clear Response </b> button
              </li>
              <li>
                To change your chosen answer, click on the bubble of another
                option.
              </li>
              <li>
                To save your answer, you MUST click on the <b>
                  Save &amp; Next
                </b>
              </li>
            </ol>
          </li>
          <li>
            <p>Procedure for answering a numerical answer type question :</p>
            <ol>
              <li>
                To enter a number as your answer, use the virtual numerical
                keypad.
              </li>
              <li>
                A fraction (e.g. -0.3 or -.3) can be entered as an answer with
                or without "0" before the decimal point. <br /><span
                  style="color: red"
                  >As many as four decimal points, e.g. 12.5435 or 0.003 or
                  -932.6711 or 12.82 can be entered.
                </span>
              </li>
              <li>
                To clear your answer, click on the <b> Clear Response </b> button
              </li>
              <li>
                To save your answer, you MUST click on the <b>
                  Save &amp; Next
                </b>
              </li>
            </ol>
          </li>
          <li>
            <p>
              To mark a question for review, click on the <b>
                Mark for Review
              </b>
              button. If an answer is selected (for MCQ) entered (for numerival
              answer type) for a question that is <b> Marked for Review </b>
              , that answer will be considered in the evaluation unless the status
              is modified by the candidate.
            </p>
          </li>
          <li>
            <p>
              To change your answer to a question that has already been
              answered, first select that question for answering and then follow
              the procedure for answering that type of question.
            </p>
          </li>
          <li>
            <p>
              Note that ONLY Questions for which answers are <b> saved </b> or
              <b> marked for review after answering </b> will be considered for evaluation.
            </p>
          </li>
          <li>
            <p>
              Sections in this question paper are displayed on the top bar of
              the screen. Questions in a Section can be viewed by clicking on
              the name of that Section. The Section you are currently viewing
              will be highlighted.
            </p>
          </li>
          <li>
            <p>
              After clicking the <b> Next Section </b> button for the last question
              in a Section, you will automatically be taken to the first question
              of the next Section in sequence.
            </p>
          </li>
          <li>
            <p>
              You can click on the name of a Section to view the answering
              status for that Section.
            </p>
          </li>
        </ol>
      </div>
      <div class="inst-user-info">
        <div class="profile-pic">
          <div class="circle-avatar">
            <img src="/images/user.jpg" alt="" />
          </div>
        </div>

        <div class="userData">
          <b>Name:</b> <span id="userName">{userObj.name}</span>
          <br />
          <b>Mobile No:</b> <span id="userEmail">{userObj.mobileNo}</span>
        </div>
      </div>
    </div>
    <div class="inst-footer">
      <div class="f1"></div>
      <button
        class="bottom-btn primary-color"
        on:click={() => {
          location.reload();
        }}
      >
        Refresh
      </button>
      <button
        class="bottom-btn primary-color"
        on:click={() => {
          navigate("/instructions/" + token);
        }}
      >
        Next
      </button>
    </div>
  </div>
{/if}
